import { useEffect, useRef } from "react";
import { getCompanyId } from "services/identity.service";
import { useContext } from "react";
import { SessionContext } from "components/SessionContext";
import { useRouter } from "next/router";
import { trackHelpWidgetClick } from "lib/analytics/posthog-helper";

export default function FreshworksChatWidget({ fullName, email }) {
  const router = useRouter();
  const companyId = getCompanyId();
  const currentUser = useContext(SessionContext);
  const isSuperAdmin = router.pathname.startsWith('/superadmin');
  const matchedCompany = currentUser?.company?.find(c => c.id === companyId);
  const widgetReadyRef = useRef(false);

  let companyName;
  if (isSuperAdmin) {
    companyName = "Super Admin";
  } else if (matchedCompany?.companyName) {
    companyName = matchedCompany.companyName;
  } else {
    companyName = "";
  }

  // Effect 1: Initialize widget ONCE
  useEffect(() => {
    if (!fullName || !email) return;

    // Clear Freshworks localStorage BEFORE initializing
    Object.keys(localStorage).forEach(key => {
      if (key.includes('wcfc')) {
        localStorage.removeItem(key);
      }
    });

    window.fcSettings = {
      onInit: function() {
        // Now set fresh data
        window.fcWidget.user.setFirstName(fullName); 
        window.fcWidget.user.setProperties({
          cf_company_name_test: companyName,
          email: email
        });
        widgetReadyRef.current = true;
        
        // Track when help widget is opened
        window.fcWidget.on("widget:opened", function() {
          trackHelpWidgetClick({
            widgetType: 'help_widget',
            currentPage: router.pathname,
          });
        });
      }
    };

    // Load the Freshworks widget script
    const script = document.createElement("script");
    script.src = "//in.fw-cdn.com/32208262/1179713.js";
    script.async = true;
    script.setAttribute("chat", "true");
    script.setAttribute("widgetId", "21a9abed-b3b7-414c-bf40-d2cc1e32d753");
    document.body.appendChild(script);
  }, []);

  // Effect 2: Update company name when it changes
  useEffect(() => {
    if (!widgetReadyRef.current || !window.fcWidget) return;

    if (window.fcWidget && window.fcWidget.user) {
      // ONLY update company name property, don't touch firstName
      window.fcWidget.user.setProperties({
        cf_company_name_test: companyName,
      });
    }
  }, [companyName]); // Only depend on companyName, NOT fullName

  return null;
}